import { rsoClientDataSlice } from "../reducers/rsoClient/rsoClient.slice";

export const {
  setIsLoading,
  setBase64Image,
  setIsCookieExpired,
  removeError,
  resetAppErrorCode,
} = rsoClientDataSlice.actions;
